import React from 'react';
import { useNavigate } from "react-router-dom";
import { Helmet } from 'react-helmet-async';
import { PROD } from '../../../../common/constants';
import { Card, Container, Grid, Button, Stack, CardContent, Typography } from '@mui/material';
function PlantScmKnowledgeManagement() {
  const navigate = useNavigate()
  return (
    <>
      <Helmet>
        <title> Home | ABEPL </title>
      </Helmet>
      <Container maxWidth="xl">
        <Grid container>
          <Grid item xs={12} lg={12}>
            <Stack spacing={1}>
              {!PROD && <p className='pageNumberingResc'>RES06</p>}
              <Grid container spacing={1}>
                <Grid item xs={12} lg={6}>
                  <Card style={{ borderRadius: 10 }}>
                    <CardContent>
                      <Stack spacing={1}>
                        <Typography variant="h5" sx={{ mb: 2, fontWeight: 'bold', fontSize: '4vh' }}>
                          Add Training Material
                        </Typography>
                        <Button sx={{ padding: '5px 10px', alignSelf: 'flex-end' }}
                          size="medium"
                          variant="contained"
                          onClick={() => (navigate('scmMemberUploadFile'))}>Proceed</Button>
                      </Stack>
                    </CardContent>
                  </Card>
                </Grid>
                <Grid item xs={12} lg={6}>
                  <Card style={{ borderRadius: 10 }}>
                    <CardContent>
                      <Stack spacing={1}>
                        <Typography variant="h5" sx={{ mb: 2, fontWeight: 'bold', fontSize: '4vh' }} >
                          View/Download Training Material
                        </Typography>
                        <Button sx={{ padding: '5px 10px', alignSelf: 'flex-end' }}
                          size="medium"
                          variant="contained"
                          onClick={() => (navigate('viewKnowledgeManagement'))}>Proceed</Button>
                      </Stack>
                    </CardContent>
                  </Card>
                </Grid>
              </Grid>
            </Stack>
          </Grid>
        </Grid>
      </Container>
    </>
  )
}

export default PlantScmKnowledgeManagement;